import { Component, OnDestroy, OnInit } from '@angular/core';
import { HelperProvider } from '../providers/helper.provider';
import { Page } from '../model/page';
import { RestService } from '../providers/rest.service';
import { Talep } from '../model/talep';
import { TaleplerPage } from '../model/talepler-page';
import { Router } from '@angular/router';
import { Pair } from '../model/pair';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/auth/auth.service';

@Component({
  selector: 'app-talepler',
  templateUrl: './talepler.component.html',
  styleUrls: ['./talepler.component.css']
})
export class TaleplerComponent implements OnInit, OnDestroy {

  REDEDILDI = Talep.REDEDILDI;
  DURUM_ONAY_SURECI = Talep.DURUM_ONAY_SURECI;
  DURUM_TEKLIF_TOPLA = Talep.DURUM_TEKLIF_TOPLA;
  DURUM_SIPARIS_OLUSTURULDU = Talep.DURUM_SIPARIS_OLUSTURULDU;
  DURUM_IRSALIYE_OLUSTURULDU = Talep.DURUM_IRSALIYE_OLUSTURULDU;

  showSearchResultCount = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  talepAraLoading = false;
  talepAraText = '';
  source: TaleplerPage = null;
  showSearchCurrentPage = 1;
  filterStatus: Pair[] = [];
  private subscriptions: Subscription[] = [];

  isOnayimdakiler: boolean = false;

  constructor(private helperProvider: HelperProvider,
    private restService: RestService,
    private router: Router,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.filterStatus.push(new Pair(this.REDEDILDI, true));
    this.filterStatus.push(new Pair(this.DURUM_ONAY_SURECI, true));
    this.filterStatus.push(new Pair(this.DURUM_TEKLIF_TOPLA, true));
    this.filterStatus.push(new Pair(this.DURUM_SIPARIS_OLUSTURULDU, true));
    this.filterStatus.push(new Pair(this.DURUM_IRSALIYE_OLUSTURULDU, true));
    this.helperProvider.currentPage$.next(Page.Talepler);
    this.isOnayimdakiler = this.authService.getIsConfirm();

    this.subscriptions.push(this.helperProvider.isConfirmation$.subscribe(res => {
      if (res != null) {
        this.isOnayimdakiler = this.authService.getIsConfirm();
        this.getTalepler();
      }
    }));

    this.subscriptions.push(this.helperProvider.changedSelectedBranches$.subscribe(res => {
      if (res != null) {
        this.getTalepler();
      }
    }));

    this.getTalepler();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getTalepler() {
    const durum = this.filterStatus.filter(x => x.value).map(x => x.key);
    this.restService.talepler(this.showSearchCurrentPage, this.showSearchResultCount, durum, this.talepAraText, this.isOnayimdakiler).subscribe(res => {
      this.source = res;
      this.source.isTalep = true;
    });
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPage--;
    this.getTalepler();
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPage++;
    this.getTalepler();
  }

  talepAraInputChange() {
    this.showSearchCurrentPage = 1;
    this.getTalepler();
  }

  new() {
    this.router.navigate(['talep'], { queryParams: { id: '0' } });
  }


  filter(selected: string) {
    for (const f of this.filterStatus) {
      if (f.key === selected) {
        f.value = !f.value;
      }
    }
    this.getTalepler();
  }

  getDurumText(key: any) {
    return Talep.getDurumText(key);
  }
}
